import styled from "styled-components";

const S = {
    Wrapper:styled.div`
    display:flex;
    flex-direction:column;
    padding:60px 100px;
    margin: 0;
    align-items:center;
    background: linear-gradient(135deg, #ffffff 0%, #f0fbfc 100%);
    border-top: 1px solid rgba(0, 169, 196, 0.1);
    border-bottom: 1px solid rgba(0, 169, 196, 0.1);
    
    @media (max-width:1024px){
        padding:40px 20px;
        margin: 0;
    }
    `,
    Sol:styled.div`
        width: 100%;
        margin-bottom: 50px;
        text-align: center;
        
        a {
            text-decoration:none;
            p {
                margin: 0;
                b {
                    font-size: 3.5em;
                    font-weight: 800;
                    color: #1a2b34;
                    letter-spacing: -1px;

                    @media (max-width: 768px) {
                        font-size: 2.5em;
                    }
                }
            }
        }
    `,
    Sag:styled.div`
        width:100%;
        max-width: 1400px;
    `,
    Dip:styled.div`
        margin-top:50px;
        width:100%;
        display: flex;
        justify-content: center;

        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            background: #00A9C4;
            color: #fff;
            padding: 14px 36px;
            border-radius: 12px;
            font-size: 1.1em;
            font-weight: 600;
            box-shadow: 0px 8px 20px rgba(0, 169, 196, 0.25);
            transition: all 0.3s ease;
            border: 2px solid #00A9C4;

            svg {
                transition: transform 0.3s ease;
                fill: #fff;
            }

            &:hover {
                background: #008ba1;
                border-color: #008ba1;
                transform: translateY(-3px);
                box-shadow: 0px 12px 30px rgba(0, 169, 196, 0.4);
                
                svg {
                    transform: translateX(6px);
                }
            }
        }
    `
};

export default S;